// Angular modules
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';
// External modules
import { DataTablesModule } from 'angular-datatables';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgSelectModule } from '@ng-select/ng-select';
// Components
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { ExpedienteComponent } from './expediente/expediente.component';
import { ProximasComponent } from './proximas/proximas.component';
import { DetalleComponent } from './detalle/detalle.component';
import { AgregarComponent } from './agregar/agregar.component';
import { ReportesComponent } from './reportes/reportes.component';
import { NuevaSesionComponent } from './nueva-sesion/nueva-sesion.component';
import { GruposComponent } from './grupos/grupos.component';
import { HeaderComponent } from './header/header.component';
import { SesionIndividualComponent } from './sesion-individual/sesion-individual.component';
import { SesionGrupalComponent } from './sesion-grupal/sesion-grupal.component';
import { DetalleSgrupalComponent } from './detalle-sgrupal/detalle-sgrupal.component';
// NgBootstrap components
import {
  NgbDatepickerModule,
  NgbModule,
  NgbTimepickerModule,
} from '@ng-bootstrap/ng-bootstrap';
import { JsonPipe } from '@angular/common';
// Locales
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { AlumnosComponent } from './alumnos/alumnos.component';

registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ExpedienteComponent,
    ProximasComponent,
    DetalleComponent,
    AgregarComponent,
    ReportesComponent,
    NuevaSesionComponent,
    GruposComponent,
    HeaderComponent,
    SesionIndividualComponent,
    SesionGrupalComponent,
    DetalleSgrupalComponent,
    AlumnosComponent,
  ],
  imports: [
    NgbModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    FormsModule,
    JsonPipe,
    BrowserModule,
    FontAwesomeModule,
    DataTablesModule,
    NgSelectModule,
    RouterModule.forRoot([
      { path: '', component: GruposComponent, data: { requiresLogin: true } },
      { path: 'login', component: LoginComponent },
      {
        path: 'agregar',
        component: AgregarComponent,
        data: { requiresLogin: true },
      },
      {
        path: 'sesion',
        component: NuevaSesionComponent,
        data: { requiresLogin: true },
      },
      {
        path: 'alumnos',
        component: ExpedienteComponent,
        data: { requiresLogin: true },
      },
      {
        path: 'lista-alumnos',
        component: AlumnosComponent,
        data: { requiresLogin: true },
      },
      {
        path: 'sesiones-grupales',
        component: SesionGrupalComponent,
        data: { requiresLogin: true },
      },
      {
        path: 'sesion-individual',
        component: SesionIndividualComponent,
        data: { requiresLogin: true },
      },
      {
        path: 'detalle-grupal',
        component: DetalleSgrupalComponent,
        data: { requiresLogin: true },
      },
      {
        path: 'detalle-individual',
        component: DetalleComponent,
        data: { requiresLogin: true },
      },
      {
        path: 'reporte',
        component: ReportesComponent,
        data: { requiresLogin: true },
      },
      { path: '**', redirectTo: '/', pathMatch: 'full' },
    ]),
    BrowserAnimationsModule,
    NgbModule,
  ],
  providers: [
    provideHttpClient(),
    {
      provide: LOCALE_ID,
      useValue: 'es',
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
